import { Component } from 'react'
import i18n from '@/i18n'

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }
  static getDerivedStateFromError(error) { return { error } }
  componentDidCatch(error, info) { console.error('ErrorBoundary:', error, info) }
  reset = () => this.setState({ error: null })

  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen items-center justify-center p-6">
          <div className="max-w-md text-center">
            <h1 className="mb-2 text-2xl font-semibold">{i18n.t('errors.genericTitle')}</h1>
            <p className="mb-4 text-sm text-muted-foreground break-words">
              {this.state.error?.message ?? i18n.t('errors.unknown')}
            </p>
            <button
              type="button"
              onClick={() => location.reload()}
              className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:opacity-90"
            >
              {i18n.t('errors.reload')}
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
